import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackUsage } from '../services/usageTracker';
import { extrahiereProgrammeId, istOeffentlicheRoute, normalisiereRoute } from '../lib/usageRoute';

/** Erfasst pro Seitenwechsel ein page_view (ohne Query/Hash, nicht auf öffentlichen Routen). */
export function useUsageTracking(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    if (istOeffentlicheRoute(pathname)) return;
    trackUsage({
      eventType: 'page_view',
      route: normalisiereRoute(pathname),
      programmeId: extrahiereProgrammeId(pathname),
    });
  }, [pathname]);
}
